module.exports = __webpack_public_path__ + "img/YBMLogo.6a120372.png";